export default __webpack_public_path__ + "static/media/activated.cee4b634.svg";